// src/utils/platform.js

export function isIOSApp() {
  const ua = navigator.userAgent || "";

  return (
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
}

export const isAndroidApp = () => {
  return (
    window.AndroidBilling &&
    typeof window.AndroidBilling.subscribe === "function"
  );
};